import { apiEmpleo } from "../../util/ApiEmpleo";

export type TGoogleLoginCheckResponse = {
  token: string;
  refresh_token: string;
};

const apiGoogleLoginCheck = async (ticket: string) => {
  const res: TGoogleLoginCheckResponse = await apiEmpleo.post(
    "auth/login_check_google",
    { ticket },
    undefined,
    false
  );
  return res;
};

export { apiGoogleLoginCheck };

const startGoogleLogin = () => {
  window.location.assign(
    `${process.env.REACT_APP_FILES_URL}/auth/google_login`
  );
};

export { startGoogleLogin };
